/**
 * CSK Demo Hub — React entry point.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles/tailwind.css";
import "./styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("CSK demo hub: no #root element in document");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
